import { DEFAULT_ROW } from "app/frontend/components/eligibility/accordions/project_size/constants";
import { IProjectSizeFormData } from "app/frontend/components/eligibility/accordions/project_size/types";
import { useFormContext } from "app/frontend/contexts/useFormContext";
import { notify } from "app/frontend/utils/notifications";
import { useCallback } from "react";

export const useAddRow = () => {
    const { data, setData } = useFormContext<IProjectSizeFormData>();

    return useCallback(() => {
        if (data.plugs.length >= 3) {
            notify({
                level: "warning",
                title: "Can only have 1 - 3 plugs.",
            });
            return;
        }
        setData("plugs", [...data.plugs, { ...DEFAULT_ROW, index: data.plugs.length }]);
    }, [data.plugs, setData]);
};
